import React from 'react';

import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import styles from './filters.module.scss';

import { LeftArrow, RightArrow } from './Arrows';

const {
  slideWrapper,
  needsOptions,
} = styles;

const ItemsSlider = (props) => (
      <><ScrollMenu
          children={props.children}
          LeftArrow={LeftArrow}
          RightArrow={RightArrow}
          wrapperClassName={slideWrapper}
          scrollContainerClassName={needsOptions}/>
      </>);

export default ItemsSlider;
